var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('app-header'),_c('q-nav-bar',{attrs:{"nav":"section"},on:{"back":function($event){return _vm.$router.push(`/report/${_vm.report.uuid}/section`)}}}),_c('question-list',{attrs:{"view":"grid"},on:{"goto":_vm.goto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }